import { DataGrid, type DataGridProps, type GridValidRowModel } from '@shared/components';

import { columns, type QuestionUsage } from './columns';

type BaseQuestionUsageListProps<TRowModel extends GridValidRowModel> = Omit<
  DataGridProps<TRowModel>,
  'columns'
>;

export default function BaseQuestionUsageList(
  props: Readonly<BaseQuestionUsageListProps<QuestionUsage>>,
) {
  return (
    <DataGrid
      disableColumnMenu
      {...props}
      columns={columns}
      rowHeight={52}
      sx={(theme) => ({
        '--DataGrid-overlayHeight': '360px',
        '.MuiDataGrid-overlayWrapperInner': {
          display: 'flex',
        },
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: 'none',
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
          paddingBottom: theme.spacing(2.75),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.grey[100],
        },
      })}
    />
  );
}
